import { AppState } from '@/features/shared/app-store';

export const gtmSelectors = {
  customData: (state: AppState) => state.gtmCustomData,
  customDataInitialized: (state: AppState) => state.gtmCustomDataInitialized,
};
